import assetUtils, { Asset } from 'app-lib/assetUtils'
import { abbreviate } from 'app-lib/numberUtils'
import React, { useState } from 'react'
import { Icon, InputBasic } from 'ui-framework'
import { BigNumber } from '@0x/utils'

interface IAssetDropdownBalanceProps {
  assetsWithBalance: { token: Asset; amount: BigNumber }[]
  selectedAsset: Asset
  onSelect: (asset: Asset) => void
}

export function AssetDropdownBalance(props: IAssetDropdownBalanceProps) {
  const [state, setState] = useState({
    hideBalanceZero: true,
    checkboxId: 'input-hide-zero-balance' + Math.random(), // avoid id collision if there are multiple assetDropdown in the page
  })
  const { hideBalanceZero, checkboxId } = state
  const assetList = props.assetsWithBalance.filter(
    (asset) => asset.token !== props.selectedAsset && (hideBalanceZero ? asset.amount.gt(0) : true)
  )

  return (
    <div className="width-100p">
      {assetList.length === 0 && (
        <div className="txt-explanation txt-center">
          No other token available as collateral in your wallet.
        </div>
      )}
      {assetList.map((asset) => {
        const { displayName, spriteLogo } = assetUtils.getCommon(asset.token)
        return (
          <div
            key={asset.token}
            className="asset-dropdown-item flex-between"
            onClick={() => props.onSelect(asset.token)}>
            <span className="flex-between">
              <Icon name={spriteLogo} size={24} className="margin-right-05" />
              <b className="txt-default">{displayName}</b>
            </span>
            <span>{abbreviate(asset.amount)}</span>
          </div>
        )
      })}

      <hr className="content-separator margin-v-1" />

      <div className="padded-h-1 flex-center">
        <InputBasic
          id={checkboxId}
          type="checkbox"
          onChange={() => setState({ ...state, hideBalanceZero: !hideBalanceZero })}
          value={hideBalanceZero}
        />
        <label className="margin-left-1ch txt-subtitle" htmlFor={checkboxId}>
          {'Hide "zero" balances'}
        </label>
      </div>
    </div>
  )
}

export default React.memo(AssetDropdownBalance)
